// Image distante avec REPLI en cascade : essaie plusieurs sources distantes dans l'ordre
// (ex. blob Azure ccpubmedia, puis émulateur Azurite local) ; si toutes échouent, bascule
// sur un asset local bundlé ; et si aucun, rend `renderFallback()`.
//
// Règle produit : sur localhost on pointe le blob Azure ; s'il n'est pas disponible, on
// retombe sur Azurite (local émulé), puis sur les assets bundlés.
//
// NB : le RECADRAGE d'une image n'est PAS fait ici. L'auteur rogne l'image dans la GALLERY
// du BO (CCT-110) : l'asset servi est déjà au bon cadrage. Un « point de cadrage » appliqué
// au rendu a été retiré pour ne pas avoir deux mécanismes concurrents.
import React, { useEffect, useState } from 'react';
import { Image, ImageStyle, StyleProp } from 'react-native';

interface Props {
  uris?: (string | null | undefined)[]; // candidats distants, par ordre de priorité
  uri?: string | null;                  // raccourci pour un seul candidat
  fallback?: any;                       // asset local bundlé si tous les distants échouent
  style?: StyleProp<ImageStyle>;
  resizeMode?: 'cover' | 'contain' | 'stretch' | 'center';
  renderFallback?: () => React.ReactNode; // dernier recours (ni distant, ni asset local)
}

export default function RemoteImage({ uris, uri, fallback, style, resizeMode = 'cover', renderFallback }: Props) {
  const candidates = (uris ?? [uri]).filter((u): u is string => !!u);
  const [idx, setIdx] = useState(0);
  // Réinitialise quand la liste de sources change (recyclage de cartes en liste).
  useEffect(() => { setIdx(0); }, [candidates.join('|')]);

  if (idx < candidates.length) {
    return (
      <Image
        source={{ uri: candidates[idx] }}
        style={style}
        resizeMode={resizeMode}
        onError={() => setIdx((i) => i + 1)}
      />
    );
  }
  if (fallback) {
    return <Image source={fallback} style={style} resizeMode={resizeMode} />;
  }
  return <>{renderFallback ? renderFallback() : null}</>;
}
